module.exports = __webpack_public_path__ + "img/5-min.bd5ad8dd.jpg";